import { FC, ReactNode } from 'react'

import styles from './greenBanner.module.scss'

type Props = {
  children: ReactNode | ReactNode[]
}

const GreenBanner: FC<Props> = props => {
  return <div className={styles['green-banner']}>{props.children}</div>
}

export default GreenBanner
